import { createContext } from 'react';
import { SpoolsType } from './spoolsType';

const spoolsContext = createContext({} as SpoolsType);

export default spoolsContext;
